module.exports = __webpack_public_path__ + "static/banner-rads-649238543c3012f0fb3b2a06475fbf09.jpg";